import evacuation_shelter from '../../assets/img/marker/m_evacuation-shelter.png'
import lv2 from '../../assets/img/marker/m_lv2.png';
import lv0 from '../../assets/img/marker/m_lv0.png';
import m_pin_blue from '../../assets/img/marker/m_pin_blue.png';
import m_pin_sky from '../../assets/img/marker/m_pin_sky.png';
import m_pin_orange from '../../assets/img/marker/m_pin_orange.png';
import m_bridge from '../../assets/img/marker/m_bridge.png';
import m_footbridge from '../../assets/img/marker/m_footbridge.png';
import m_tunnel from '../../assets/img/marker/m_tunnel.png';
import m_road from '../../assets/img/marker/m_road.png';
import m_road_shed from '../../assets/img/marker/m_road-shed.png';
import m_dam from '../../assets/img/marker/m_dam.png';

import m_kishou_snow from '../../assets/img/marker/m_kishou-snow.png';

import m_road_hosou from '../../assets/img/marker/m_road_hosou.png';
import m_road_norimen from '../../assets/img/marker/m_road_norimen.png';

import m_teibou_gogan from '../../assets/img/marker/m_teibou-gogan.png';
import m_haisui_kouwan from '../../assets/img/marker/m_haisui-kouwan.png';
import m_kasen_tunnel from '../../assets/img/marker/m_kasen-tunnel.png';
import m_chika_chousei_ike from '../../assets/img/marker/m_chika-chousei-ike.png';
import m_chousei_ike from '../../assets/img/marker/m_chousei-ike.png';
import m_haisui_kasen from '../../assets/img/marker/m_haisui-kasen.png';

import m_entei_kou from '../../assets/img/marker/m_entei-kou.png';
import m_keiryu_hozen from '../../assets/img/marker/m_keiryu-hozen.png';
import m_kyuu_keisha from '../../assets/img/marker/m_kyuu-keisha.png';
import m_jisuberi from '../../assets/img/marker/m_jisuberi.png';

import m_suimon from '../../assets/img/marker/m_suimon.png';

import m_kouwan_gaikaku from '../../assets/img/marker/m_kouwan_gaikaku.png';
import m_gyokou_keiryuu from '../../assets/img/marker/m_gyokou_keiryuu.png';
import m_kouwan_keiryuu from '../../assets/img/marker/m_kouwan_keiryuu.png';
import m_kouwan_rinkou from '../../assets/img/marker/m_kouwan_rinkou.png';
import m_kaigan_shisetsu from '../../assets/img/marker/m_kaigan-shisetsu.png';
import m_gyokou_gaikaku from '../../assets/img/marker/m_gyokou_gaikaku.png';
import m_gyokou_rinkou from '../../assets/img/marker/m_gyokou_rinkou.png';

import m_denshou_info from '../../assets/img/marker/m_sabou_info.png';
import m_denshou_stone from '../../assets/img/marker/m_denshou-info.png';
import m_denshou_record from '../../assets/img/marker/m_sabou_record.png';

// 道路規制のバッジ
import m_road_i_mae from '../../assets/img/marker/m_road-i_mae.png';
import m_road_i_saigai from '../../assets/img/marker/m_road-i_saigai.png';
import m_road_i_touki from '../../assets/img/marker/m_road-i_touki.png';

import m_road_i_heisa from '../../assets/img/marker/m_road-i-heisa.png';
import m_road_i_oogata from '../../assets/img/marker/m_road-i-oogata.png';
import m_road_i_katagawa from '../../assets/img/marker/m_road-i-katagawa.png';
import m_road_i_taimen from '../../assets/img/marker/m_road-i-taimen.png';
import m_road_i_shasen from '../../assets/img/marker/m_road-i-shasen.png';
import m_road_i_taiya from '../../assets/img/marker/m_road-i-taiya.png';
import m_road_i_hokou from '../../assets/img/marker/m_road-i-hokou.png';
import m_road_i_other from '../../assets/img/marker/m_road-i-other.png';

import m_road_r_rain from '../../assets/img/marker/m_road-r-rain.png';
import m_road_r_wind from '../../assets/img/marker/m_road-r-wind.png';
import m_road_r_wave from '../../assets/img/marker/m_road-r-wave.png';
import m_road_r_kansui from '../../assets/img/marker/m_road-r-kansui.png';
import m_road_r_bridge from '../../assets/img/marker/m_road-r-bridge.png';
import m_road_r_winter from '../../assets/img/marker/m_road-r-winter.png';
import m_road_camera from '../../assets/img/marker/m_road-camera.png';
import m_road_condition from '../../assets/img/marker/m_road-condition.png';
import m_road_camera_condition from '../../assets/img/marker/m_road-camera-condition.png';

import m_rainfall_0 from '../../assets/img/marker/weather/m_rainfall_0.png';
import m_rainfall_1 from '../../assets/img/marker/weather/m_rainfall_1.png';
import m_rainfall_2 from '../../assets/img/marker/weather/m_rainfall_2.png';
import m_rainfall_3 from '../../assets/img/marker/weather/m_rainfall_3.png';
import m_rainfall_4 from '../../assets/img/marker/weather/m_rainfall_4.png';
import m_rainfall_5 from '../../assets/img/marker/weather/m_rainfall_5.png';
import m_rainfall_6 from '../../assets/img/marker/weather/m_rainfall_6.png';
import m_rainfall_7 from '../../assets/img/marker/weather/m_rainfall_7.png';


import m_water_0 from '../../assets/img/marker/weather/m_suii_0.png';
import m_water_1 from '../../assets/img/marker/weather/m_suii_1_joushou.png';
import m_water_2 from '../../assets/img/marker/weather/m_suii_2_joushou.png';
import m_water_2_kakou from '../../assets/img/marker/weather/m_suii_2_kakou.png';
import m_water_3 from '../../assets/img/marker/weather/m_suii_3_joushou.png';
import m_water_4 from '../../assets/img/marker/weather/m_suii_4_joushou.png';
import m_water_5 from '../../assets/img/marker/weather/m_suii_5_joushou.png';
import m_water_6 from '../../assets/img/marker/weather/m_suii_6_joushou.png';

import m_dam_1 from '../../assets/img/marker/weather/m_dam-suii_1.png';
import m_dam_2 from '../../assets/img/marker/weather/m_dam-suii_2.png';
import m_dam_3 from '../../assets/img/marker/weather/m_dam-suii_3.png';
import m_dam_4 from '../../assets/img/marker/weather/m_dam-suii_4.png';
import m_dam_5 from '../../assets/img/marker/weather/m_dam-suii_5.png';


import m_wind_0 from '../../assets/img/marker/weather/m_fuukou_0.png';
import m_wind_1 from '../../assets/img/marker/weather/m_fuukou_1.png';
import m_wind_2 from '../../assets/img/marker/weather/m_fuukou_2.png';
import m_wind_3 from '../../assets/img/marker/weather/m_fuukou_3.png';
import m_wind_4 from '../../assets/img/marker/weather/m_fuukou_4.png';
import m_wind_5 from '../../assets/img/marker/weather/m_fuukou_5.png';
import m_wind_6 from '../../assets/img/marker/weather/m_fuukou_6.png';
import m_wind_7 from '../../assets/img/marker/weather/m_fuukou_7.png';

import m_tide_1 from '../../assets/img/marker/weather/m_choui_1.png';
import m_tide_2 from '../../assets/img/marker/weather/m_choui_2.png';
import m_tide_3 from '../../assets/img/marker/weather/m_choui_3_joushou.png';
import m_tide_3_kakou from '../../assets/img/marker/weather/m_choui_3_kakou.png';
import m_tide_4 from '../../assets/img/marker/weather/m_choui_4_joushou.png';
import m_tide_5 from '../../assets/img/marker/weather/m_choui_5_joushou.png';



import m_camera_dam from '../../assets/img/marker/m_camera-dam.png';
import m_camera_kaigan from '../../assets/img/marker/m_camera-kaigan.png';
import m_camera_kouwan from '../../assets/img/marker/m_camera-kouwan.png';
import m_camera_park from '../../assets/img/marker/m_camera-park.png';
import m_camera_river from '../../assets/img/marker/m_camera-river.png';
import m_camera_road from '../../assets/img/marker/m_camera-road.png';
import m_camera_sabou from '../../assets/img/marker/m_camera-sabou.png';
import m_camera_tameike from '../../assets/img/marker/m_camera-tameike.png';

import m_sea__route from '../../assets/img/marker/m_sea-__route.png';
import m_kyuukeishachi from '../../assets/img/marker/m_kyuukeishachi.png';
import m_steep_slope_law from "../../assets/img/marker/m_steep-slope_law.png";
import m_bombed_tree from "../../assets/img/marker/m_bombed-tree.png";


import m_morido_01 from "../../assets/img/marker/m_morido_01.png";
import m_morido_02 from "../../assets/img/marker/m_morido_02.png";
import m_morido_03 from "../../assets/img/marker/m_morido_03.png";

import m_dourodaichou from '../../assets/img/marker/m_dourodaichou.png';
import m_infra_tourism from '../../assets/img/marker/m_infra-tourism.png';
import m_emergency_phone from '../../assets/img/marker/m_emergency-phone.png';
import m_apartment from '../../assets/img/marker/m_apartment.png';
import m_kofun from '../../assets/img/marker/m_bunka_kofun.png';
import m_kofun_90_11_3 from '../../assets/img/marker/m_bunka_kaizuka.png';
import m_kofun_90_11_4 from '../../assets/img/marker/m_bunka_shuraku.png';
import m_kofun_90_11_5 from '../../assets/img/marker/m_bunka_tojo_kanga.png';
import m_kofun_90_11_6 from '../../assets/img/marker/m_bunka_jokan.png';
import m_kofun_90_11_7 from '../../assets/img/marker/m_bunka_shaji.png';
import m_kofun_90_11_8 from '../../assets/img/marker/m_bunka_seisan.png';
import m_kofun_90_11_9 from '../../assets/img/marker/m_bunka_funbo.png';
import m_kofun_90_11_10 from '../../assets/img/marker/m_bunka_kindai.png';
import m_kofun_90_11_11 from '../../assets/img/marker/m_bunka_sonota.png';
import m_kofun_90_11_12 from '../../assets/img/marker/m_bunka_suichu.png';


// 学校
import m_98_3 from '../../assets/img/marker/m_fs-shogakko.png';
import m_98_4 from '../../assets/img/marker/m_fs-chugakko.png';
import m_98_5 from '../../assets/img/marker/m_fs-chutokyoiku-gakko.png';
import m_98_6 from '../../assets/img/marker/m_fs-kotogakko.png';
import m_98_7 from '../../assets/img/marker/m_fs-senmongakko.png';
import m_98_8 from '../../assets/img/marker/m_fs-tankidaigaku.png';
import m_98_9 from '../../assets/img/marker/m_fs-daigaku.png';
import m_98_10 from '../../assets/img/marker/m_fs-tokubetsushien-gakko.png';
import m_98_11 from '../../assets/img/marker/m_fs-gimukyoiku-gakko.png';
import m_98_12 from '../../assets/img/marker/m_fs-kakushu-gakko.png';
import m_98_13 from '../../assets/img/marker/m_fs-senshu-gakko.png';

// 幼稚園
import m_98_14 from '../../assets/img/marker/m_fh-yochien.png';
import m_98_15 from '../../assets/img/marker/m_fh-kodomoen.png';
import m_98_16 from '../../assets/img/marker/m_fh-hoikusho.png';
import m_98_17 from '../../assets/img/marker/m_fh-tiikigata-hoiku.png';
import m_98_18 from '../../assets/img/marker/m_fh-ninkagai-hoiku.png';

// 医療機関
import m_98_19 from '../../assets/img/marker/m_fh-byoin.png';
import m_98_20 from '../../assets/img/marker/m_fh-shinryosho.png';  
import m_98_21 from '../../assets/img/marker/m_fh-shika.png';

// 福祉施設
import m_98_22 from '../../assets/img/marker/m_ff-hogoshisetsu.png';
import m_98_23 from '../../assets/img/marker/m_ff-rojinfukushi.png';
import m_98_24 from '../../assets/img/marker/m_ff-shogaishashien.png';
import m_98_25 from '../../assets/img/marker/m_ff-shintaishogaisha.png';  
import m_98_26 from '../../assets/img/marker/m_ff-jidofukushi.png';
import m_98_27 from '../../assets/img/marker/m_ff-boshi-fushi.png';
import m_98_28 from '../../assets/img/marker/m_ff-sonota-shakaifukushi.png';

// 図書館
import m_98_29 from '../../assets/img/marker/m_f-toshokan.png';

// 役場
import m_98_30 from '../../assets/img/marker/m_f-yakuba.png';  
import m_98_31 from '../../assets/img/marker/m_f-kominkan.png';

// 駅
import m_98_32 from '../../assets/img/marker/m_ft-shinkansen.png';
import m_98_33 from '../../assets/img/marker/m_ft-zairaisen.png';
import m_98_34 from '../../assets/img/marker/m_ft-sonota.png';

// マンホール
import m_manhole from '../../assets/img/marker/m_manhole.png';


const id2Icon = {
    "hinanjo": evacuation_shelter,
    "tameike": m_pin_sky,
    "sabou": lv2,
    "sabousetsubi": lv0,
    "tunnel": m_tunnel,
    "kyoryo": m_bridge,
    "hodokyo": m_footbridge,
    "doro-shed": m_road_shed,
    "doro-mongata": m_road,
    "damu": m_dam,
    "77_2_kyukeisha": m_pin_orange,
    "boring": m_pin_blue,
    "data1": m_pin_blue,
    "data2": m_pin_blue,
    "sekisetusin_6_10": m_kishou_snow,
    // "kasenkanri_17": m_teibou_gogan,
    "vis_18": m_haisui_kouwan,
    "vis_19": m_kasen_tunnel,
    "vis_20": m_chika_chousei_ike,
    "vis_21": m_chousei_ike,
    "vis_22": m_haisui_kasen,
    "vis_32": m_pin_blue,
    "vis_34": m_pin_blue,
    "vis_36": m_pin_blue,
    "vis_38": m_pin_blue,
    "vis_39": m_pin_blue,
    "vis_103": m_pin_blue,
    "sabo_25": m_entei_kou,
    "sabo_26": m_keiryu_hozen,
    "sabo_27": m_kyuu_keisha,
    "sabo_28": m_jisuberi,
    "suimon_29": m_suimon,
    "kouwan_30_1": m_kouwan_gaikaku,
    "kouwan_30_4": m_kaigan_shisetsu,
    "kouwan_30_5": m_gyokou_gaikaku,
    "kouwan_30_2": m_kouwan_keiryuu,
    "kouwan_30_3": m_kouwan_rinkou,
    "kouwan_30_6": m_gyokou_keiryuu,
    "kouwan_30_7": m_gyokou_rinkou,
    "kasenkanri_31": m_pin_blue,
    "vis_66": m_denshou_info,
    "chiiki_sabo_67": m_pin_blue,

    "vis_78_3": m_kyuukeishachi,
    "vis_87_road": m_pin_blue,
    "vis_87_river": m_pin_orange,
    
    "vis_89": m_sea__route,
    "vis_90_3": m_steep_slope_law,
    "vis_90_15": m_bombed_tree,
    "vis_90_16_3": m_morido_01,
    "vis_90_16_4": m_morido_02,
    "vis_90_16_5": m_morido_03,
    "vis_92": m_dourodaichou,
    "vis_94": m_infra_tourism,
    "vis_95": m_emergency_phone,
    "vis_95_7": m_apartment,
    "vis_90_11_2": m_kofun,
    "vis_90_11_3": m_kofun_90_11_3,
    "vis_90_11_4": m_kofun_90_11_4,
    "vis_90_11_5": m_kofun_90_11_5,
    "vis_90_11_6": m_kofun_90_11_6,
    "vis_90_11_7": m_kofun_90_11_7,
    "vis_90_11_8": m_kofun_90_11_8,
    "vis_90_11_9": m_kofun_90_11_9,
    "vis_90_11_10": m_kofun_90_11_10,
    "vis_90_11_11": m_kofun_90_11_11,
    "vis_90_11_12": m_kofun_90_11_12,
    "vis_97_4": m_pin_blue,

    "vis_98_3": m_98_3,
    "vis_98_4": m_98_4,
    "vis_98_5": m_98_5,
    "vis_98_6": m_98_6,
    "vis_98_7": m_98_7,
    "vis_98_8": m_98_8,
    "vis_98_9": m_98_9,
    "vis_98_10": m_98_10,
    "vis_98_11": m_98_11,
    "vis_98_12": m_98_12,
    "vis_98_13": m_98_13,
    "vis_98_14": m_98_14,
    "vis_98_15": m_98_15,
    "vis_98_16": m_98_16,
    "vis_98_17": m_98_17,
    "vis_98_18": m_98_18,
    "vis_98_19": m_98_19,
    "vis_98_20": m_98_20,
    "vis_98_21": m_98_21,
    "vis_98_22": m_98_22,
    "vis_98_23": m_98_23,
    "vis_98_24": m_98_24,
    "vis_98_25": m_98_25,
    "vis_98_26": m_98_26,
    "vis_98_27": m_98_27,
    "vis_98_28": m_98_28,
    "vis_98_29": m_98_29,
    "vis_98_30": m_98_30,
    "vis_98_31": m_98_31,
    "vis_98_32": m_98_32,
    "vis_98_33": m_98_33,
    "vis_98_34": m_98_34,
    "vis_98_35": m_pin_blue,
    "vis_96_1": m_pin_blue,

    "vis_99_1": m_haisui_kasen,
    "vis_99_2": m_manhole,
    "vis_99_4": m_haisui_kasen,
    
};

const accordionMenuIcons = {

    // 06: 道路カメラ・冬季道路情報
    "sekisetusin_6_10": [
        {"label": "カメラ", "img": m_road_camera},
        {"label": "データ", "img": m_road_condition},
        {"label": "カメラとデータ ", "img": m_road_camera_condition},
    ],

    "vis_32": [
        {"label": "40mm以上", "img": m_rainfall_7},
        {"label": "30mm以上", "img": m_rainfall_6},
        {"label": "20mm以上 ", "img": m_rainfall_5},
        {"label": "10mm以上 ", "img": m_rainfall_4},
        {"label": "1mm以上 ", "img": m_rainfall_3},
        {"label": "無降雨 ", "img": m_rainfall_2},
        {"label": "欠測 ", "img": m_rainfall_1},
        {"label": "閉局・メンテナンス ", "img": m_rainfall_0},
    ],

    "vis_34": [
        {"label": "はん濫危険", "img": m_water_6},
        {"label": "避難判断", "img": m_water_5},
        {"label": "はん濫注意 ", "img": m_water_4},
        {"label": "水防団待機", "img": m_water_3},
        {"label": "平常", "img": m_water_2},
        {"label": "欠測 ", "img": m_water_1},
        {"label": "閉局・メンテナンス ", "img": m_water_0},
        {"label": "上昇(変化なし) ", "img": m_water_2},
        {"label": "下降中 ", "img": m_water_2_kakou},
    ],

    "vis_36": [
        {"label": "サーチャージ水位", "img": m_dam_5},
        {"label": "ただし書き操作開始水位", "img": m_dam_4},
        {"label": "常時満水位 ", "img": m_dam_3},
        {"label": "平常", "img": m_dam_2},
        {"label": "欠測 ", "img": m_dam_1},
    ],

    "vis_39": [
        {"label": "25m/s以上", "img": m_wind_7},
        {"label": "20m/s以上", "img": m_wind_6},
        {"label": "15m/s以上 ", "img": m_wind_5},
        {"label": "10m/s以上 ", "img": m_wind_4},
        {"label": "5m/s以上 ", "img": m_wind_3},
        {"label": "5m/s未満 ", "img": m_wind_2},
        {"label": "欠測 ", "img": m_wind_1},
        {"label": "閉局・メンテナンス ", "img": m_wind_0},
    ],

    "vis_38": [
        {"label": "警戒潮位", "img": m_tide_5},
        {"label": "注意潮位", "img": m_tide_4},
        {"label": "平常 ", "img": m_tide_3},
        {"label": "欠測", "img": m_tide_2},
        {"label": "閉局・メンテナンス ", "img": m_tide_1},
        {"label": "上昇(変化なし)  ", "img": m_tide_3},
        {"label": "下降中 ", "img": m_tide_3_kakou},
    ],
    
    // # 63_1: 河川管理情報システム (河川防災情報システム)	土砂災害危険度情報	土砂災害危険度テキストデータ　1kmメッシュ
    "vis_63_1": [
        {"label": "実況で特別警報(土砂災害)基準超過", "class" : "h-dosha-lv5"},
        {"label": "2時間後までに基準値超過", "class" : "h-dosha-lv4"},
        {"label": "大雨警報(土砂災害)基準の超過", "class" : "h-dosha-lv3"},
        {"label": "大雨注意報基準の超過", "class" : "h-dosha-lv2"},
    ],
    
    // 66: 連携データNo65-67：地域の砂防情報アーカイブ
    "vis_66": [
        {"label": "被災情報等", "img": m_denshou_info},
        {"label": "石碑", "img": m_denshou_stone},
        {"label": "記録集 ", "img": m_denshou_record},
    ],
    
    // 87: 県のカメラ画像の一元化（一覧化）	
    "vis_87": [
        {"label": "道路", "img": m_camera_road},
        {"label": "河川", "img": m_camera_river},
        {"label": "ダム", "img": m_camera_dam},
        {"label": "砂防", "img": m_camera_sabou},
        {"label": "港湾", "img": m_camera_kouwan},
        {"label": "海岸", "img": m_camera_kaigan},
        {"label": "公園", "img": m_camera_park},
        {"label": "ため池", "img": m_camera_tameike},
    ],

    "vis_90_1": [
        {"label": "開発行為許可（法第29条）"},
        {"label": "開発許可の特例（法第34条の2）"},
        {"label": "変更許可（法第35条の2）"},
        {"label": "田園居住地内の建築制限（法第52条）"},
        {"label": "市街地開発事業等予定地区内の建築制限（法第52条の2）"},
        {"label": "都市計画施設等の建築許可（法第53条）"},
        {"label": "風致地区内における規制（法第58条）"},
        {"label": "都市計画区域内の届出（法第58条の2）"},
        {"label": "地区計画区域内での建築許可（法第58条の3）"},
        {"label": "都市計画事業の施行に係る建築制限等（法第65条）"},
    ],

    "vis_90_2": [
        {"label": "制限行為の許可"},
        {"label": "砂防設備占用許可"}
    ],

    "vis_90_3": [
        {"label": "制限行為の許可"},
    ],

    "vis_90_4": [
        {"label": "制限行為の許可"},
    ],

    "vis_90_5": [
        {"label": "保安林（国有林含む）における伐採制限（法第34条第1項）等"},
    ],
    
    "vis_90_6": [
        {"label": "国立，国定公園での行為の許可，届出"},
        {"label": "県自然公園での行為の許可，届出"},
    ],

    "vis_90_7": [
        {"label": "県自然環境保全地域での行為の許可，届出"},
        {"label": "緑地環境保全地域での届出"},
        {"label": "県自然海浜保全地区での行為の許可，届出"},
    ],

    "vis_90_8": [
        {"label": "道路工事に関する承認（第24条）"},
        {"label": "道路占用の許可（第32条）"},
        {"label": "限度超過車両の通行許可（法第47条の2）"},
        {"label": "連結許可（法第48条の5）"},
        {"label": "行為の制限（法第91条第1項・第2項）"},
    ],

    "vis_90_9": [
        {"label": "河川工事の承認（法第20条）"},
        {"label": "流水占用の許可（法第23条）"},
        {"label": "河川敷地の占用許可（法第24条）"},
        {"label": "土石，草木等の採取（法第25条）"},
        {"label": "工作物新築等の許可（法第26条第1項）"},
        {"label": "河川敷地の掘削，盛土等（法第27条）"},
        {"label": "竹木等流送の許可（法第28条）"},
    ],

    "vis_90_10": [
        {"label": "土木工事等の許可（条例第1条・2条）"},
    ],

    "vis_100": [
        {"label": "雨水浸透阻害行為の許可（第30条）"},
        {"label": "雨水貯留浸透施設の機能を阻害するおそれのある行為の許可（第39条）"},
    ],

    "vis_90_11": [
        {"label": "国指定天然記念物等の現状変更許可（法第125条外）"},
        {"label": "埋蔵文化財事業計画変更通知（法第93・94条）"},
        {"label": "埋蔵文化財の不時発見の通知，協議（法第96・97条）"},
    ],

    "vis_90_12": [
        {"label": "工事着工前の届出，通知（法第10条・11条）"},
    ],

    "vis_90_13": [
        {"label": "土砂搬出の届出（第8条）"},
        {"label": "一時堆積土砂搬出の届出（第9条）"},
        {"label": "土砂の埋立，盛土その他の堆積許可（第16条）"},
    ],

    "vis_90_14": [
        {"label": "土地形質変更の届出（第3条第7項，第4条第1項）"},
    ],
    
    // 91: 地震被害想定図
    "vis_91": [
        {"label": "震度7", "class" : "h-jishin-lv7"},
        {"label": "震度6強", "class" : "h-jishin-lv6up"},
        {"label": "震度6弱", "class" : "h-jishin-lv6low"},
        {"label": "震度5強", "class" : "h-jishin-lv5up"},
        {"label": "震度5弱", "class" : "h-jishin-lv5low"},
        {"label": "震度4", "class" : "h-jishin-lv4"},
        {"label": "震度3以下", "class" : "h-jishin-lv3"},
    ],
}

const dorokiseiIcon = {
    "dorokisei_1": [
        {"label": "通行止め", "img": m_road_i_heisa},
        {"label": "車線規制", "img": m_road_i_shasen},
        {"label": "片側交互通行", "img": m_road_i_katagawa} ,
        {"label": "対面通行", "img": m_road_i_taimen} ,
        {"label": "歩行者・二輪車通行止め", "img": m_road_i_hokou},
        {"label": "大型車通行止め", "img": m_road_i_oogata},
        {"label": "冬用タイヤ規制", "img": m_road_i_taiya},
        {"label": "その他", "img": m_road_i_other},
      
        {"label": "規制区間", "class": "icon-no h-road-i-closed is-low"},
        {"label": "迂回路", "class": "icon-no h-road-i-ukai is-low"},
      
        {"label": "表示の種類について(例）", "type": "description"},
      
        {"label": "事前の規制", "img": m_road_i_mae},
        {"label": "冬季の規制", "img": m_road_i_touki},
        {"label": "災害の規制", "img": m_road_i_saigai}
      
    ],
    "dorokisei_2": [
        {"label": "通行止め", "img": m_road_i_heisa},
        {"label": "車線規制", "img": m_road_i_shasen},
        {"label": "片側交互通行", "img": m_road_i_katagawa} ,
        {"label": "対面通行", "img": m_road_i_taimen} ,
        {"label": "歩行者・二輪車通行止め", "img": m_road_i_hokou},
        {"label": "大型車通行止め", "img": m_road_i_oogata},
        {"label": "冬用タイヤ規制", "img": m_road_i_taiya},
        {"label": "その他", "img": m_road_i_other},

        {"label": "規制区間", "class": "icon-no h-road-i-closed is-low"},
        {"label": "迂回路", "class": "icon-no h-road-i-ukai is-low"},

        {"label": "表示の種類について(例）", "type": "description"},

        {"label": "事前の規制", "img": m_road_i_mae},
        {"label": "冬季の規制", "img": m_road_i_touki},
        {"label": "災害の規制", "img": m_road_i_saigai}

    ],
    "dorokisei_3": [
        {"label": "事前通行規制区間", "class": "h-road-i-jizen is-low"},
        {"label": "雨による規制区間", "img": m_road_r_rain},
        {"label": "風による規制区間", "img": m_road_r_wind} ,
        {"label": "越波による規制区間", "img": m_road_r_wave},
        {"label": "冠水による規制区間", "img": m_road_r_kansui},
        {"label": "海田大橋\n広島はつかいち大橋の通行規制区間", "img": m_road_r_bridge},
        {"label": "冬季閉鎖区間", "img": m_road_r_winter},
    ],
    "dorokisei_4": [
        {"label": "落石やがけ崩れの発生するおそれが高い区間", "class": "h-road-i-soukou-01 is-low"},
        {"label": "落石やがけ崩れの発生するおそれがやや高い区間", "class": "h-road-i-soukou-02 is-low"},
    ],
    "dorokisei_5": [
        {"label": "第一次緊急輸送道路（高規格幹線道路）", "class": "h-road-i-kinkyuu-01 is-low"},
        {"label": "第一次緊急輸送道路（その他）", "class": "h-road-i-kinkyuu-02 is-low"},
        {"label": "第二次緊急輸送道路", "class": "h-road-i-kinkyuu-03 is-low"} ,
        {"label": "第三次緊急輸送道路", "class": "h-road-i-kinkyuu-04 is-low"},
    ],
}

// 浸水系メニューの共通の凡例
const commonWaterLegend = [
    { range: "0.0-0.3",   color: "#ffffb3", class: "h-shinsui-lv1"},
    { range: "0.3-0.5",   color: "#f7f5a9", class: "h-shinsui-lv2"},
    { range: "0.5-1.0",   color: "#f8e1a6", class: "h-shinsui-lv3"},
    { range: "1.0-3.0",   color: "#ffd8c0", class: "h-shinsui-lv4"},
    { range: "3.0-5.0",   color: "#ffb7b7", class: "h-shinsui-lv5"},
    { range: "5.0-10.0",  color: "#ff9191", class: "h-shinsui-lv6"},
    { range: "10.0-20.0", color: "#f285c9", class: "h-shinsui-lv7"},
    { range: "20.0-（m）", color: "#dc7adc", class: "h-shinsui-lv8"},
]

const commonTownLegend = [
    { range: "田", color: "#ffffb3", class: "h-toshi-toti-01", subTitle: "自然的土地利用"},
    { range: "畑", color: "#ffffb3", class: "h-toshi-toti-02"},
    { range: "山林", color: "#ffffb3", class: "h-toshi-toti-03"},
    { range: "水面", color: "#ffffb3", class: "h-toshi-toti-04"},
    { range: "耕作放棄地", color: "#ffffb3", class: "h-toshi-toti-05"},
    { range: "その他の自然地", color: "#ffffb3", class: "h-toshi-toti-06"},
    { range: "住宅用地", color: "#ffffb3", class: "h-toshi-toti-07", subTitle: "都市的土地利用"},
    { range: "商業用地（1ha以上）", color: "#ffffb3", class: "h-toshi-toti-08"},
    { range: "商業用地（1ha未満）", color: "#ffffb3", class: "h-toshi-toti-09"},
    { range: "工業用地（2ha以上）", color: "#ffffb3", class: "h-toshi-toti-10"},
    { range: "工業用地（2ha未満）", color: "#ffffb3", class: "h-toshi-toti-11"},
    { range: "農林漁業施設用地", color: "#ffffb3", class: "h-toshi-toti-12"},
    { range: "公益施設用地", color: "#ffffb3", class: "h-toshi-toti-13"},
    { range: "道路用地", color: "#ffffb3", class: "h-toshi-toti-14"},
    { range: "交通施設用地", color: "#ffffb3", class: "h-toshi-toti-15"},
    { range: "公共空地", color: "#ffffb3", class: "h-toshi-toti-16"},
    { range: "その他公的施設用地", color: "#ffffb3", class: "h-toshi-toti-17"},
    { range: "その他の空地①", color: "#ffffb3", class: "h-toshi-toti-18"},
    { range: "その他の空地②", color: "#ffffb3", class: "h-toshi-toti-19"},
    { range: "その他の空地③", color: "#ffffb3", class: "h-toshi-toti-20"},
    { range: "その他の空地④", color: "#ffffb3", class: "h-toshi-toti-21"},
    { range: "低未利用土地", color: "#ffffb3", class: "h-toshi-toti-22"},
]

// 建物利用現況
const commonBuildingLegend = [
    { range: "業務施設", class: "h-toshi-tatemono-01"},
    { range: "商業施設", class: "h-toshi-tatemono-02"},
    { range: "宿泊施設", class: "h-toshi-tatemono-03"},
    { range: "商業系用途複合施設", class: "h-toshi-tatemono-04"},
    { range: "住宅", class: "h-toshi-tatemono-05"},
    { range: "共同住宅", class: "h-toshi-tatemono-06"},
    { range: "店舗等併用住宅", class: "h-toshi-tatemono-07"},
    { range: "店舗等併用共同住宅", class: "h-toshi-tatemono-08"},
    { range: "作業所併用住宅", class: "h-toshi-tatemono-09"},
    { range: "官公庁施設", class: "h-toshi-tatemono-10"},
    { range: "文教厚生施設", class: "h-toshi-tatemono-11"},
    { range: "運輸倉庫施設", class: "h-toshi-tatemono-12"},
    { range: "工場", class: "h-toshi-tatemono-13"},
    { range: "農林漁業用施設", class: "h-toshi-tatemono-14"},
    { range: "供給処理施設", class: "h-toshi-tatemono-15"},
    { range: "防衛施設", class: "h-toshi-tatemono-16"},
    { range: "その他", class: "h-toshi-tatemono-17"},
    // { range: "空家", class: "h-toshi-tatemono-18"},
    { range: "不明", class: "h-toshi-tatemono-19"},
]

// 性別年齢別人口
const commonPlanningPopulationLegend = [
    { range: "0 - 100以下", class: "h-toshi-pop-gender-age-lv1"},
    { range: "101 - 500以下", class: "h-toshi-pop-gender-age-lv2"},
    { range: "501 - 1,000以下", class: "h-toshi-pop-gender-age-lv3"},
    { range: "1,001 - 2,000以下", class: "h-toshi-pop-gender-age-lv4"},
    { range: "2,001 - 4,000以下", class: "h-toshi-pop-gender-age-lv5"},
    { range: "4,001 - （40人/ha）", class: "h-toshi-pop-gender-age-lv6"},
]

const legendArrays = { 
    "kasen" : commonWaterLegend,
    "kasen-saidai" : commonWaterLegend,
    "kasen-keizoku" : [
        { range: "0 - 12", color: "#ffffb3", class: "h-shinsui-time-lv1"},
        { range: "12 - 24", color: "#f7f5a9", class: "h-shinsui-time-lv2"},
        { range: "24 - 72", color: "#f8e1a6", class: "h-shinsui-time-lv3"},
        { range: "72 - 168", color: "#ffd8c0", class: "h-shinsui-time-lv4"},
        { range: "168 - 336", color: "#ffb7b7", class: "h-shinsui-time-lv5"},
        { range: "336 - 672", color: "#ff9191", class: "h-shinsui-time-lv6"},
        { range: "672 - （h）", color: "#f285c9", class: "h-shinsui-time-lv7"},
    ],
    "tsunami"         : [
        { range: "0.3m未満",   color: "#ffffb3", class: "h-shinsui-lv1"},
        { range: "0.3m以上0.5m未満",   color: "#f7f5a9", class: "h-shinsui-lv2"},
        { range: "0.5m以上1m未満",   color: "#f8e1a6", class: "h-shinsui-lv3"},
        { range: "1m以上3m未満",   color: "#ffd8c0", class: "h-shinsui-lv4"},
        { range: "3m以上5m未満",   color: "#ffb7b7", class: "h-shinsui-lv5"},
        { range: "5m以上",  color: "#ff9191", class: "h-shinsui-lv6"}
    ],
    "takashio"        : commonWaterLegend,
    "takashio-isewan" : commonWaterLegend,
    "takashio-saidai" : commonWaterLegend,
    "toshi_85_1_11" : [
        { range: "第一種低層住居専用地域", color: "#ffffb3", class: "h-toshi-youto-01"},
        { range: "第二種低層住居専用地域", color: "#ffffb3", class: "h-toshi-youto-02"},
        { range: "第一種中高層住居専用地域", color: "#ffffb3", class: "h-toshi-youto-03"},
        { range: "第二種中高層住居専用地域", color: "#ffffb3", class: "h-toshi-youto-04"},
        { range: "第一種住居地域", color: "#ffffb3", class: "h-toshi-youto-05"},
        { range: "第二種住居地域", color: "#ffffb3", class: "h-toshi-youto-06"},
        { range: "準住居地域", color: "#ffffb3", class: "h-toshi-youto-07"},
        { range: "田園住居地域", color: "#ffffb3", class: "h-toshi-youto-08"},
        { range: "近隣商業地域", color: "#ffffb3", class: "h-toshi-youto-09"},
        { range: "商業地域", color: "#ffffb3", class: "h-toshi-youto-10"},
        { range: "準工業地域", color: "#ffffb3", class: "h-toshi-youto-11"},
        { range: "工業地域", color: "#ffffb3", class: "h-toshi-youto-12"},
        { range: "工業専用地域", color: "#ffffb3", class: "h-toshi-youto-13"},
    ],
    "85_2_1_land_250m" : commonTownLegend,
    "85_2_2_land_town" : commonTownLegend,
    "85_2_3_land_site" : commonTownLegend,
    
    // 建物
    "85_3_1_building_250m" : commonBuildingLegend,
    "85_3_2_building_town" : commonBuildingLegend,
    "85_3_3_building_building" : commonBuildingLegend,

    // 性別年齢別人口
    "85_4_1_population_500m" : commonPlanningPopulationLegend,
    "85_4_2_population_town" : commonPlanningPopulationLegend,

    "vis_93_1" : commonTownLegend,
    "vis_93_2" : commonTownLegend,
    "vis_93_3" : commonTownLegend,
    
    // 徒歩圏内の施設充実度
    "vis_95_1" : [
        {type: "hidden", color: "transparent", maxValue:50},
        {range: "50-55", color: "#9ea0f3", maxValue:55, class: "h-toho-jyuujitsu-lv1"},
        {range: "55-60", color: "#a4c9f4", maxValue:60, class: "h-toho-jyuujitsu-lv2"},
        {range: "60-65", color: "#acf2f6", maxValue:65, class: "h-toho-jyuujitsu-lv3"},
        {range: "65-70", color: "#b8f5dc", maxValue:70, class: "h-toho-jyuujitsu-lv4"},
        {range: "70-75", color: "#c5f8bf", maxValue:75, class: "h-toho-jyuujitsu-lv5"},
        {range: "75-80", color: "#d4e9b6", maxValue:80, class: "h-toho-jyuujitsu-lv6"},
        {range: "80-85", color: "#e4daa2", maxValue:85, class: "h-toho-jyuujitsu-lv7"},
        {range: "85-90", color: "#f4caa5", maxValue:90, class: "h-toho-jyuujitsu-lv8"},
        {range: "90-95", color: "#ee9c82", maxValue:95, class: "h-toho-jyuujitsu-lv9"},
        {range: "95-100", color: "#e86a5e", maxValue:1000, class: "h-toho-jyuujitsu-lv10"}
    ],
    // 徒歩圏内の高低差
    "vis_95_2" : [
        {range: "0-55", color: "#ffd976", maxValue:55.1, class: "h-toho-kouteisa-lv6"},
        {range: "55-78", color: "#feb24c", maxValue:78.4, class: "h-toho-kouteisa-lv5"},
        {range: "78-98", color: "#fd8d3c", maxValue:98.4, class: "h-toho-kouteisa-lv4"},
        {range: "98-120", color: "#fc4e2a", maxValue:120.3, class: "h-toho-kouteisa-lv3"},
        {range: "120-150", color: "#e31a1c", maxValue:150, class: "h-toho-kouteisa-lv2"},
        {range: "150-390", color: "#b10026",maxValue:1000,  class: "h-toho-kouteisa-lv1"},
    ],
    // 徒歩圏内の緑比率
    "vis_95_3" : [
        {range: "0-5", color: "#a4dea5", maxValue:5, class: "h-toho-ryokuhiritsu-lv9"},
        {range: "5-10", color: "#a4e19e", maxValue:10, class: "h-toho-ryokuhiritsu-lv8"},
        {range: "10-15", color: "#3fd03d", maxValue:15, class: "h-toho-ryokuhiritsu-lv7"},
        {range: "15-20", color: "#14a22d", maxValue:20, class: "h-toho-ryokuhiritsu-lv6"},
        {range: "20-25", color: "#0d8019", maxValue:25, class: "h-toho-ryokuhiritsu-lv5"},
        {range: "25-30", color: "#12581b", maxValue:30, class: "h-toho-ryokuhiritsu-lv4"},
        {range: "30-40", color: "#0b4807", maxValue:40, class: "h-toho-ryokuhiritsu-lv3"},
        {range: "40-50", color: "#074101", maxValue:50, class: "h-toho-ryokuhiritsu-lv2"},
        {range: "50-100", color: "#1a4004", maxValue:101, class: "h-toho-ryokuhiritsu-lv1"},
    ],
    // 空き家件数（250mメッシュ）
    "vis_95_4" : [
        {range: "少ない", color: "#aeabaf", maxValue:0, class: "h-akiya250-lv1"},
        {range: "", color: "#3e9bfe", maxValue:1, class: "h-akiya250-lv2"},
        {range: "", color: "#45f885",maxValue:2,  class: "h-akiya250-lv3"},
        {range: "", color: "#e0de37", maxValue:3, class: "h-akiya250-lv4"},
        {range: "", color: "#f15d13", maxValue:4, class: "h-akiya250-lv5"},
        {range: "多い", color: "#7a0403", maxValue:5, class: "h-akiya250-lv6"},
    ],
    // 空き家件数（町丁目）
    "vis_95_5" : [
        { range: "少ない", color: "#aeabaf", maxValue:0, class: "h-akiyaritsu-lv1"},
        { range: "", color: "#4686fb", maxValue:1, class: "h-akiyaritsu-lv2"},
        { range: "", color: "#1be5b5", maxValue:2, class: "h-akiyaritsu-lv3"},
        { range: "", color: "#a4fc3c", maxValue:3, class: "h-akiyaritsu-lv4"},
        { range: "", color: "#fbb938", maxValue:4, class: "h-akiyaritsu-lv5"},
        { range: "", color: "#e3440a", maxValue:5, class: "h-akiyaritsu-lv6"},
        { range: "多い", color: "#7a0403", maxValue:6, class: "h-akiyaritsu-lv7"},
    ],
    // 空き家率（町丁目）
    "vis_95_6" : [
        { range: "低い", color: "#969696", maxValue:0, class: "h-akiya-lv1"},
        { range: "", color: "#4686fb", maxValue:1, class: "h-akiya-lv2"},
        { range: "", color: "#1be5b5", maxValue:2, class: "h-akiya-lv3"},
        { range: "", color: "#a4fc3c", maxValue:3, class: "h-akiya-lv4"},
        { range: "", color: "#fbb938", maxValue:4, class: "h-akiya-lv5"},
        { range: "", color: "#e3440a", maxValue:5, class: "h-akiya-lv6"},
        { range: "高い", color: "#7a0403", maxValue:6, class: "h-akiya-lv7"},
    ],
}

export {
    id2Icon,
    dorokiseiIcon,
    legendArrays,
    accordionMenuIcons
}
